import React, { useEffect } from "react";
import PaymentPageHeader from "../../Component/PaymentPageHeader/PaymentPageHeader.jsx";
import PaymentPageSidebar from "../../Component/PaymentPageSidebar/PaymentPageSidebar.jsx";
import Footer from "../../Component/Footer/Footer.jsx";
import { ProfileService } from "./ProfileService.js";
import { API_BASEURLICON } from "../../Config.js";
import { RingLoader } from "react-spinners";

const Profile = () => {
  const {
    balanceData,
    getBalanceUser,
    getProfileReport,
    profileReportData,
    getTagetAchievement,
    targetAchievePopup,
    targetAchieveData,
    setTargetAchievePopup,
    loading,
  } = ProfileService();

  useEffect(() => {
    getProfileReport();
    getBalanceUser();
  }, []);

  return (
    <>
      <PaymentPageHeader />
      <div className="main-container">
        <div className="main-wrapper">
          <PaymentPageSidebar />
          <div className="main-content cus-entry-form-wrapper">
            <div className="bank-accounts-container account-container false">
              <div className="desktop-header">Profile</div>

              <div className="row">
                <div className="cus-column-75">
                  <div className="bank-entry-section">
                    <div className="bank-account-form-wrapper">
                      <form className="bank-entry-form">
                        <div className="cus-form-flex-area">
                          <div className="sc-bf9dbd6b-0 AeIlZ input-wrapper  ">
                            <div className="sc-bf9dbd6b-1 dvWaXF input-container">
                              <p className="sc-bf9dbd6b-3 zIslH input-label-without-animation ">
                                Name
                              </p>
                              <input
                                type="text"
                                className="sc-bf9dbd6b-4 lfrTwo"
                                name="name"
                                value={profileReportData?.name}
                                readOnly
                              />
                            </div>
                          </div>
                          <div className="sc-bf9dbd6b-0 AeIlZ input-wrapper  ">
                            <div className="sc-bf9dbd6b-1 dvWaXF input-container">
                              <p className="sc-bf9dbd6b-3 zIslH input-label-without-animation ">
                                EmailId
                              </p>
                              <input
                                type="text"
                                className="sc-bf9dbd6b-4 lfrTwo"
                                name="emailID"
                                value={profileReportData?.emailID}
                                readOnly
                              />
                            </div>
                          </div>
                        </div>

                        <div className="cus-form-flex-area">
                          <div className="sc-bf9dbd6b-0 AeIlZ input-wrapper  ">
                            <div className="sc-bf9dbd6b-1 dvWaXF input-container">
                              <p className="sc-bf9dbd6b-3 zIslH input-label-without-animation ">
                                Mobile No.
                              </p>
                              <input
                                type="text"
                                className="sc-bf9dbd6b-4 lfrTwo"
                                name="mobileNo"
                                value={profileReportData?.mobileNo}
                                readOnly
                              />
                            </div>
                          </div>
                          <div className="sc-bf9dbd6b-0 AeIlZ input-wrapper  ">
                            <div className="sc-bf9dbd6b-1 dvWaXF input-container">
                              <p className="sc-bf9dbd6b-3 zIslH input-label-without-animation ">
                                Alternate No.
                              </p>
                              <input
                                type="text"
                                className="sc-bf9dbd6b-4 lfrTwo"
                                name="alternateMobile"
                                value={profileReportData?.alternateMobile}
                                readOnly
                              />
                            </div>
                          </div>
                        </div>

                        <div className="cus-form-flex-area">
                          <div className="sc-bf9dbd6b-0 AeIlZ input-wrapper  ">
                            <div className="sc-bf9dbd6b-1 dvWaXF input-container">
                              <p className="sc-bf9dbd6b-3 zIslH input-label-without-animation ">
                                DOB
                              </p>
                              <input
                                type="text"
                                className="sc-bf9dbd6b-4 lfrTwo"
                                name="dob"
                                value={profileReportData?.dob}
                                readOnly
                              />
                            </div>
                          </div>

                          <div className="sc-bf9dbd6b-0 AeIlZ input-wrapper  ">
                            <div className="sc-bf9dbd6b-1 dvWaXF input-container">
                              <p className="sc-bf9dbd6b-3 zIslH input-label-without-animation ">
                                Address
                              </p>
                              <input
                                type="text"
                                className="sc-bf9dbd6b-4 lfrTwo"
                                name="address"
                                value={profileReportData?.address}
                                readOnly
                              />
                            </div>
                          </div>
                        </div>

                        <div className="cus-form-flex-area">
                          <div className="sc-bf9dbd6b-0 AeIlZ input-wrapper">
                            <div className="sc-bf9dbd6b-1 dvWaXF input-container">
                              <p className="sc-bf9dbd6b-3 zIslH input-label-without-animation ">
                                City
                              </p>
                              <input
                                type="text"
                                className="sc-bf9dbd6b-4 lfrTwo cus-3flex"
                                name="city"
                                value={profileReportData?.city}
                                readOnly
                              />
                            </div>
                          </div>
                          <div className="sc-bf9dbd6b-0 AeIlZ input-wrapper">
                            <div className="sc-bf9dbd6b-1 dvWaXF input-container">
                              <p className="sc-bf9dbd6b-3 zIslH input-label-without-animation ">
                                State
                              </p>
                              <input
                                type="text"
                                className="sc-bf9dbd6b-4 lfrTwo cus-3flex"
                                name="state"
                                value={profileReportData?.state}
                                readOnly
                              />
                            </div>
                          </div>
                          <div className="sc-bf9dbd6b-0 AeIlZ input-wrapper ifsc-code-container">
                            <div className="sc-bf9dbd6b-1 dvWaXF input-container">
                              <p className="sc-bf9dbd6b-3 zIslH input-label-without-animation">
                                PinCode
                              </p>
                              <input
                                type="text"
                                className="sc-bf9dbd6b-4 lfrTwo cus-3flex"
                                name="pincode"
                                value={profileReportData?.pincode}
                                readOnly
                              />
                            </div>
                          </div>
                        </div>

                        <div className="cus-form-flex-area">
                          <div className="sc-bf9dbd6b-0 AeIlZ input-wrapper">
                            <div className="sc-bf9dbd6b-1 dvWaXF input-container">
                              <p className="sc-bf9dbd6b-3 zIslH input-label-without-animation ">
                                PAN
                              </p>
                              <input
                                type="text"
                                className="sc-bf9dbd6b-4 lfrTwo"
                                name="pan"
                                value={profileReportData?.pan}
                                readOnly
                              />
                            </div>
                          </div>
                          <div className="sc-bf9dbd6b-0 AeIlZ input-wrapper">
                            <div className="sc-bf9dbd6b-1 dvWaXF input-container">
                              <p className="sc-bf9dbd6b-3 zIslH input-label-without-animation ">
                                Aadhar
                              </p>
                              <input
                                type="text"
                                className="sc-bf9dbd6b-4 lfrTwo"
                                name="aadhar"
                                value={profileReportData?.aadhar}
                                readOnly
                              />
                            </div>
                          </div>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>

                <div className="cus-column-25">
                  <div className="sc-bf9dbd6b-0 AeIlZ input-wrapper  cus-image-wrapper-area">
                    <div className="sc-bf9dbd6b-1 dvWaXF input-container">
                      <img
                        src={
                          profileReportData?.profilePic
                            ? `${API_BASEURLICON}${profileReportData.profilePic}`
                            : `/assets/pwa-static/pwa/images/header/avtar.png`
                        }
                        alt="icon"
                        width="50"
                        height="50"
                      />
                    </div>
                  </div>

                  {balanceData?.isB2CTarget && (
                    <div>
                      <button
                        type="button"
                        className="cus-kyc-btn cus-kyc-btn-outline-secondary"
                        onClick={() => getTagetAchievement()}
                      >
                        Target Achievement
                      </button>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
      {targetAchievePopup && (
        <>
          <div className="modal-overlay">
            <div className="modal-content">
              <button onClick={() => setTargetAchievePopup(false)}>
                &times;
              </button>

              <div className="transactions-table-container">
                <div className="head-section">
                  <p className="payment-heading">Target List</p>
                </div>
                <div
                  style={{
                    overflowX: "auto",
                    overflowY: "auto",
                    maxHeight: "400px",
                  }}
                >
                  <table className="transactions-table">
                    <thead>
                      <tr>
                        <th>#</th>
                        <th>MembershipType</th>
                        <th>Service Name</th>
                        <th>Target</th>
                        <th>Achieved</th>
                        <th>Remaining</th>
                      </tr>
                    </thead>
                    <tbody>
                      {loading ? (
                        <tr>
                          <td colSpan="8" style={{ textAlign: "center" }}>
                            <RingLoader color="#5a6876" size={50} />
                          </td>
                        </tr>
                      ) : targetAchieveData?.length > 0 ? (
                        targetAchieveData.map((item, index) => (
                          <tr className="transaction-item" key={index}>
                            <td>{index + 1}</td>
                            <td>{item?.MembershipType}</td>
                            <td>{item?.ServiceName}</td>
                            <td>{item?.Target}</td>
                            <td>{item?.Achieved}</td>
                            <td>{item?.Pending}</td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan="8" style={{ textAlign: "center" }}>
                            !!! 😐 😐 No Data found 😐 😐 !!!
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default Profile;
